import { parseHash } from "@/utils/searchParams";
import { useSearchParams } from "next/navigation";

export const useIsNewCustomerLink = () => {
  const searchParams = useSearchParams();
  return parseHash(searchParams).get("phase") === "contract";
};
